import { ResourceRole } from "gitpod-next-api/gitpod/v1/group_pb";

export type OrgRoleConfig = {
    role: ResourceRole;
    label: string;
    description: string;
};

export const ORG_ROLES: OrgRoleConfig[] = [
    {
        role: ResourceRole.ORG_RUNNERS_ADMIN,
        label: "Runners Admin",
        description: "Can create and manage all runners in the organization",
    },
    {
        role: ResourceRole.ORG_PROJECTS_ADMIN,
        label: "Projects Admin",
        description: "Can create and manage all projects in the organization",
    },
    {
        role: ResourceRole.ORG_AUTOMATIONS_ADMIN,
        label: "Automations Admin",
        description: "Can create and manage all automations in the organization",
    },
    {
        role: ResourceRole.ORG_GROUPS_ADMIN,
        label: "Groups Admin",
        description: "Can create and manage all groups in the organization",
    },
];

export function getOrgRoleLabel(role: ResourceRole): string | undefined {
    return ORG_ROLES.find((r) => r.role === role)?.label;
}
